import React from 'react';
import FieldSummaryPreview from '../../cards/FieldSummaryPreview/FieldSummaryPreview';
import { PanelCards } from '../../Panel';
import { APPLICATION, FHA, HARVEST, PLANTING, WEATHER } from '../../../constants/cards';

const CARDS = [WEATHER, APPLICATION, PLANTING, HARVEST, FHA];

interface FieldSummaryPanelProps {
  index?: number;
  isCollapsed?: boolean;
  isSplitViewEnabled?: boolean;
}

function FieldSummaryPanel({ index, isCollapsed, isSplitViewEnabled }: FieldSummaryPanelProps) {
  const firstCard =
    isSplitViewEnabled && isCollapsed ? <FieldSummaryPreview /> : undefined;
  return (
    <PanelCards
      cards={CARDS}
      firstCard={firstCard}
      index={index || 0}
      isCollapsed={isCollapsed || false}
      testId="field-summary"
    />
  );
}

export default FieldSummaryPanel;